<div class="d-md-flex justify-content-center align-items-center heightContent100">
  <div class="w-50 text-center notfound-404">
      <h1>Oops!</h1>
      <h2>404 - The Page can't be found</h2>
  </div>
</div>